import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import AbsolutePane from './_absolute-pane.js'

export default {
  name: 'ProgressBar',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    titleLabel: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 8px 0',
        },
        style: {
          textAlign: 'center',
        },
      },
    },
    rangeLabelsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          padding: '0 0 2px 0',
          justifyContent: 'space-between',
        },
      },
    },
    rangeLabelContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          width: '100%',
        },
      },
    },
    rangeLabel: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    isRangeLabelRatio: true,
    progressLineContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          maxHeight: '8px',
          minHeight: '8px',
        },
      },
    },
    progressLineBackground: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '100%',
          height: '100%',
        },
      },
    },
    progressLine: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          height: '100%',
          left: 0,
        },
      },
    },
    progressLineLabel: {
      configSet: Text,
      configValues: {
        container: {
          padding: '2px 0 0',
        },
      },
    },
    limitLabelsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '2px 0 0 0',
          justifyContent: 'space-between',
        },
      },
    },
    limitLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
